import { useColumns } from "./useColumns";
import { useSession } from "./useSession";
import { useTables } from "./useTables";

export const useAppSession = (options?: { deferSchema?: boolean }) => {
    const session = useSession();
    const deferSchema = options?.deferSchema ?? false;

    const tables = useTables({
        enabled: !!session.data && !deferSchema,
        retry: false,
    });

    const columns = useColumns({
        enabled: tables.isSuccess && !deferSchema,
        retry: false,
    });

    return {
        isLoading: deferSchema
            ? session.isLoading || session.isError
            : session.isLoading || tables.isLoading || columns.isLoading || session.isError,
        session,
        tables,
        columns,
    };
};
